<template>
  <b-container fluid class="question-form__slider-wrapper mt-3">
    <b-row>
      <b-col cols="12" class="mb-3 pb-2">
        <div
          v-if="withLabel"
          class="font-weight-bold v3_color_black_knight pb-2"
        >
          {{ jobQuestionVariable.input_label }}
        </div>
        <slider-input
          :disabled="noPreferenceSelected"
          :initial-value="preferenceValue"
          :variable="jobQuestionVariable"
          @set-value="sliderSet"
        />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import SliderInput from '@/components/study/form/SliderInput';

export default {
  name: 'SliderPreferenceOneVarInput',
  components: {
    SliderInput,
  },
  props: {
    jobQuestionVariable: {
      required: false,
    },
    jobQuestionInitialValue: {
      default: null,
    },
    noPreferenceValue: Number,
    withLabel: Boolean,
  },
  computed: {
    preferenceValue: function () {
      if (!this.jobQuestionVariable || this.noPreferenceSelected) return 0;
      const jobProfileQuestionResponse = this.jobQuestionVariable
        .jobProfileQuestionResponses[0];
      return jobProfileQuestionResponse &&
        (jobProfileQuestionResponse.value ||
          jobProfileQuestionResponse.value === 0)
        ? jobProfileQuestionResponse.value
        : this.jobQuestionInitialValue || 0;
    },
    noPreferenceSelected: function () {
      return this.noPreferenceValue === 1;
    },
  },
  methods: {
    sliderSet: function (val) {
      if (this.noPreferenceSelected) return;
      this.jobQuestionVariable.jobProfileQuestionResponses[0].value = val;
      this.$emit('set-preference', this.jobQuestionVariable.id, val);
    },
  },
};
</script>

<style lang="scss"></style>
